module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("By ")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("SJD P")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ETERSON")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Beyond Duty*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Leon")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Masters & Boyd")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Plan B*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Tuck & Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("HISPERING")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v(" P")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("INES")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v(" R")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("ANCH")]), _c('span', {
    staticClass: "t5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Lorcan’s Desire*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Quinn’s Need*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Ty’s Obsession*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Conner’s Courage*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Jess’s Journey*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Riveted (short story)")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("UARDS")]), _c('span', {
    staticClass: "t5"
  }), _c('span', {
    staticClass: "t7"
  }, [_vm._v("OF")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v(" F")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("OLSOM")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Pup*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Tag Team*")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Pony*")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Roped*")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("*Available in paperback")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Published by ")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("REAMSPINNER")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v(" P")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad4a8b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0